export default "__VITE_ASSET__03e0f52a__"